export const ftpSettingsSchema = {
  name: 'FTP Settings Schema',
  type: 'object',
  properties: {
    FtpUserName: {
      type: 'string',
      maxLength: 64,
      minLength: 6,
      required: true,
    },
    FtpNewPassword: {
      type: 'string',
      maxLength: 64,
      minLength: 6,
      required: true,
    },
    FtpConfirmPassword: {
      type: 'string',
      maxLength: 64,
      minLength: 6,
      required: true,
    },
  },
};

export const shippingSettingsSchema = {
  name: 'Shipping Settings Schema',
  type: 'object',
  properties: {
    FreeShippingMininumPurchaseAmt: {
      type: 'number',
      minimum: 0,
      maximum: 999999999,
      required: false,
    },
  },
};

export const shippingLabelsSchema = {
  name: 'Shipping Labels Schema',
  type: 'object',
  properties: {
    LabelName: {
      type: 'string',
      required: true,
    },
    ShippingRate: {
      type: 'number',
      minimum: 0,
      maximum: 999999999,
      required: true,
    },
    MinimumPurchaseAmt: {
      type: 'number',
      minimum: 0,
      maximum: 999999999,
      required: false,
    },
  },
};

